<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <vs-tab icon-pack="feather" icon="icon-list" :label="!isSmallerScreen ? 'Keychains' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">

        <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
                <keychains-form/>
            </div>

            <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
                <keychains-list/>
            </div>
        </div>

      </div>
    </vs-tab>

  </vs-tabs>
</template>

<script>
import KeychainsForm from './KeychainsForm';
import KeychainsList from './KeychainsList';

export default {
  components: {
    KeychainsForm,
    KeychainsList,
  },
  data () {
    return {
    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
